import React from "react";
import "./Slider.css";
import { useTranslation } from "react-i18next";
const Slider = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 pe-0 px-0">
            <div
              id="carouselExampleCaptions"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner d-none d-sm-block">
                <div className="carousel-item active">
                  <img
                    src="https://apimukemel.com/api/assets/brothers.webp"
                    className="w-100 imagesize"
                    alt="Mukemel Ruhun Dokunuşu kampanyası, İbrahim ve Fares Bawadikje"
                  />
                  <div className="carousel-caption ">
                    <p className="fs-11 text-uppercase fw-normal mb-2">
                      MÜKEMEL
                    </p>
                    <p className="fw-light pt-0 fs-3">{t("TOUCH OF SOUL")}</p>

                    <a
                      href="/shop"
                      className="text-white fw-light"
                      id="shopbtn"
                    >
                      {t("Shop")}
                    </a>
                  </div>
                </div>
              </div>
              <div className="carousel-inner d-block d-sm-none">
                <div className="carousel-item active">
                  <img
                    src="https://apimukemel.com/api/assets/bannermobile.webp"
                    className="w-100 h-100 imagesize2"
                    alt="Mukemel Ruhun Dokunuşu kampanyası, İbrahim ve Fares Bawadikje"
                  />
                  <div className="carousel-caption ">
                    <p className="fs-11 text-uppercase fw-normal mb-2">
                      {t("Mükemel")}
                    </p>
                    <p className="fw-light pt-0 fs-3">{t("TOUCH OF SOUL")}</p>

                    <a href="/shop" className="text-white fw-light">
                      {t("Shop")}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Slider;
